import { render, staticRenderFns } from "./CreditorInvoices.vue?vue&type=template&id=063bff4c&scoped=true"
import script from "./CreditorInvoices.vue?vue&type=script&lang=js"
export * from "./CreditorInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063bff4c",
  null
  
)

export default component.exports